import React from 'react'
import { motion } from 'framer-motion'

export default function Gallery() {
  return (
    <div style={{ minHeight: '100vh', padding: '5rem 1rem' }}>
      <div style={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
        position: 'relative',
        overflow: 'hidden'
      }}>

        <div style={{
          position: 'absolute',
          fontSize: 'clamp(6rem, 20vw, 16rem)',
          fontWeight: 900,
          color: 'rgba(255,255,255,0.03)',
          letterSpacing: '-0.02em',
          userSelect: 'none',
          pointerEvents: 'none'
        }}>GALLERY</div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '1rem',
          width: '100%',
          maxWidth: '800px',
          opacity: 0.15,
          marginBottom: '3rem',
          position: 'relative',
          zIndex: 1
        }}>
          {[...Array(6)].map((_, i) => (
            <motion.div
              key={i}
              animate={{ opacity: [0.3, 0.6, 0.3] }}
              transition={{ duration: 2, repeat: Infinity, delay: i * 0.3 }}
              style={{
                height: i === 1 || i === 4 ? '180px' : '120px',
                borderRadius: '12px',
                background: 'rgba(0,217,255,0.15)',
                border: '1px solid rgba(0,217,255,0.2)'
              }}
            />
          ))}
        </div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            fontWeight: 900,
            color: 'white',
            textTransform: 'uppercase',
            letterSpacing: '-0.02em',
            marginBottom: '1rem',
            position: 'relative',
            zIndex: 1
          }}
        >Coming Soon</motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          style={{
            color: 'rgba(255,255,255,0.4)',
            fontSize: '0.85rem',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            fontFamily: 'monospace',
            position: 'relative',
            zIndex: 1
          }}
        >Screenshots · Designs · Visual Work</motion.p>

      </div>
    </div>
  )
}
